import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagGuard {
  constructor(private config: AppConfigService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (route.data['featureFlag']) {
      var cfg = this.config.getConfig();
      var flag = route.data['featureFlag'] as string;
      return of(cfg[flag] ?? false);
    }

    return of(true);
  }
}
